<!--  -->
<template>
 <div class="pb100 worksItemDetail">
    <crumbs detail="true"/>
    <div class="container">
        <div class="title"><span>{{dataParams.worksTitle}}</span>
        <!-- <i class="rank1"></i> -->
        </div>
        <div class="details">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>{{dataParams.crtTime | relativeTime }}</el-breadcrumb-item>
              <el-breadcrumb-item>编号：{{dataParams.authorNo}}</el-breadcrumb-item>
              <el-breadcrumb-item>票数：{{dataParams.voteCount}}</el-breadcrumb-item>
              <el-breadcrumb-item>作者：{{dataParams.author}}</el-breadcrumb-item>
              <el-breadcrumb-item>浏览量：{{dataParams.pv}}</el-breadcrumb-item>
            </el-breadcrumb>

            <div class="tou" v-if="voteType === 'true'" @click="addPiao()">投票</div>
            <div class="tou no" v-if="voteType === 'false'">投票</div>
        </div>

        <div class="contents" v-html="dataParams.content">

        </div>

        <div class="navs">
          <p><span>上一篇：</span><span @click="gotodetail(prevText.id)">{{prevText.worksTitle}}</span></p>
          <p><span>下一篇：</span><span @click="gotodetail(nextText.id)">{{nextText.worksTitle}}</span></p>
        </div>
    </div>

 </div>
</template>

<script>
import {getWorkItemList, getToupiao, getWorkItemDetail} from '@/api/workCollect/index'

import crumbs from '@/components/crumbs/index'
export default {
  name: 'worksItemDetail',
  components: {
    crumbs
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      prevText: {},
      nextText: {},
      toupParams: {
        worksId: '',
        userId: ''
      },
      id: '',
      dataParams: {},
      params: {
        page: 1,
        limit: 1000,
        activityId: '',
        author: null,
        authorNo: null,
        worksTitle: null,
        voteCountSort: null,
        pvSort: null
      },
      dataList: [],
      activityId: '',
      columnId: '',
      voteType: ''
    }
  },
  created () {
    this.activityId = this.$route.query.activityId
    this.columnId = this.$route.query.columnId
    this.params.activityId = this.$route.query.activityId
    this.voteType = this.$route.query.voteType
    console.log(this.voteType)
    this.id = this.$route.query.worksId
    this.toupParams.worksId = this.$route.query.worksId
    this.toupParams.userId = this.$cookie.get('wlyuserid')
    // this.getToupiao()
    this.getWorkItemDetail()
    this.getWorkItemLists()
  },
  methods: {
    addPiao () {
      getToupiao(this.id, this.$cookie.get('wlyuserid')).then(res => {
        console.log(res, 'piao')
        this.$alert(res.data.message, '', {
          confirmButtonText: '确定'
        })
      })
    },
    getWorkItemLists () {
      getWorkItemList(this.params).then(res => {
        console.log(res, 'nhj')
        this.dataList = res.data.data.rows

        const i = this.dataList.findIndex((item) => {
          return item.id === Number(this.id)
        })
        if (i === 0) {
          this.prevText = this.dataList[this.dataList.length - 1]
          this.nextText = this.dataList[i + 1]
        } else if (i === this.dataList.length - 1) {
          this.prevText = this.dataList[i - 1]
          this.nextText = this.dataList[0]
        } else {
          this.prevText = this.dataList[i - 1]
          this.nextText = this.dataList[i + 1]
        }
      })
    },
    gotodetail (id) {
      this.$router.push({
        path: 'worksItemDetail',
        query: {
          worksId: id,
          columnId: this.columnId,
          activityId: this.activityId
        }
      })
    },
    getWorkItemDetail () {
      getWorkItemDetail(this.id).then(res => {
        console.log(res)
        this.dataParams = res.data.data
      })
    },
    getToupiao () {
      getToupiao(this.toupParams.worksId, this.toupParams.userId).then(res => {
        console.log(res)
      })
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/works.scss'
</style>



// WEBPACK FOOTER //
// src/view/workCollect/worksDetail.vue